import { render } from "./WeightList.vue?vue&type=template&id=08b58bee"
import script from "./WeightList.vue?vue&type=script&lang=js"
export * from "./WeightList.vue?vue&type=script&lang=js"

import "./WeightList.vue?vue&type=style&index=0&id=08b58bee&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__